class SummaryPanelCtrl {
  expanded = true;

  constructor() {
    //
  }

  toggle() {
    this.expanded = !this.expanded;
  }
}

export const SummaryPanelComponent = {
  transclude: {
    headerLabel: 'headerLabel',
    headerContent: '?headerContent'
  },
  controller: SummaryPanelCtrl,
  template: `<panel-container class="top-green">
                <panel-body>
                  <panel-body-content>
                    <summary-header ng-click="$ctrl.toggle();" >
                      <item-label>

                          <svg-icon ng-if="$ctrl.expanded"
                            class="apt-expand-and-collapse-icon"
                            path="/aptitude/styles/images/icons.svg#minus">
                          </svg-icon>

                          <svg-icon ng-if="!$ctrl.expanded"
                            class="apt-expand-and-collapse-icon"
                            path="/aptitude/styles/images/icons.svg#plus">
                          </svg-icon>

                          <div ng-transclude="headerLabel"></div>
                        </item-label>
                      <item-data ng-transclude="headerContent"></item-data>
                    </summary-header>
                    <summary-content ng-transclude ng-if="$ctrl.expanded">
                    </summary-content>
                  </panel-body-content>
                </panel-body>
             <panel-body-content class="flex-col">`
};
